import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { products } from '../data/products';
import './ProductDetails.css';
import EmailPopup from '../components/EmailPopup';

const ProductDetails = ({ onAddToCart }) => {
  const { id } = useParams();
  const [selectedImage, setSelectedImage] = useState(0);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [emailConfirmed, setEmailConfirmed] = useState(false);
  
  // Find the product by ID
  const product = products.find(p => p.id === parseInt(id));
  
  // Debug logging
  console.log('Product Details - Product found:', product);
  if (product) {
    console.log('Product image path:', product.image);
    console.log('Product gallery paths:', product.gallery);
  }
  
  if (!product) {
    return (
      <div className="product-not-found">
        <div className="container">
          <h2>Product Not Found</h2>
          <p>The product you're looking for doesn't exist.</p>
          <Link to="/shop" className="btn btn-primary">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleBuyNow = () => setShowEmailPopup(true);
  const handleEmailSubmit = (email, product) => {
    setShowEmailPopup(false);
    setEmailConfirmed(true);
    // Here you would proceed to payment or store email for backend
  };

  return (
    <div className="product-details-page">
      <div className="product-details section">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/shop">Shop</Link> / {product.title}
          </div>
          
          <div className="product-details-grid">
            {/* Product Images */}
            <div className="product-images">
              <div className="main-image">
                <img 
                  src={`/${product.gallery.large[selectedImage] || product.image}`} 
                  alt={product.title}
                  onError={(e) => {
                    console.log('Main image failed to load:', e.target.src);
                    e.target.src = `/${product.image}`;
                  }}
                />
              </div>
           <div className="thumbnail-images">
  {(product.gallery?.thumbs || []).map((thumb, index) => (
    <div 
      key={index}
      className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
      onClick={() => setSelectedImage(index)}
    >
      <img 
        src={thumb.startsWith('/') ? thumb : `/${thumb}`} 
        alt={`${product.title} ${index + 1}`}
        onError={(e) => {
          console.log('Thumbnail failed to load:', e.target.src);
          e.target.style.display = 'none';
        }}
      />
    </div>
  ))}
</div>

            </div>
            
            {/* Product Info */}
            <div className="product-info">
              <div className="product-category">{product.category}</div>
              <h1 className="product-title">{product.title}</h1>
              {/* <div className="product-price">OMR {product.price}</div> */}
              <div className="product-brand">
                <span>Brand: {product.brand}</span>
              </div>
              
              <div className="product-description">
                <p>{product.description}</p>
              </div>
              
              <div className="product-details-section">
                <h3>Product Details</h3>
                <div className="details-content">
                  <p>{product.details.fullDescription}</p>
                </div>
              </div>
              
              <div className="product-specs">
                <h3>Specifications</h3>
                <div className="specs-grid">
                  {product.details.weight && (
                    <div className="spec-item">
                      <strong>Weight:</strong> {product.details.weight}
                    </div>
                  )}
                  {product.details.dimensions && (
                    <div className="spec-item">
                      <strong>Dimensions:</strong> {product.details.dimensions}
                    </div>
                  )}
                  {product.details.size && (
                    <div className="spec-item">
                      <strong>Size:</strong> {product.details.size}
                    </div>
                  )}
                </div>
              </div>
              
              <div className="product-actions">
                {/* <button 
                  className="btn btn-primary"
                  onClick={() => onAddToCart({ ...product, image: `/${product.image}` })}
                >
                  <i className="fas fa-shopping-cart"></i> Add to Cart
                </button>
                <button 
                  className="btn btn-secondary"
                  onClick={handleBuyNow}
                >
                  Buy Now
                </button> */}
                <a 
                  href={`https://wa.me/96898520852?text=I%20am%20interested%20in%20this%20product:%20${encodeURIComponent(product.title)}`}
                  className="btn btn-secondary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-whatsapp"></i> Inquire on WhatsApp
                </a>
                <Link to="/contact" className="btn btn-outline">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Related Products */}
      <section className="related-products section" style={{ background: '#f7fafd' }}>
        <div className="container">
          <div className="section-title">
            <h2>Related Products</h2>
          </div>
          <div className="related-products-grid">
            {products
              .filter(p => p.category === product.category && p.id !== product.id)
              .slice(0, 3)
              .map(relatedProduct => (
                <div key={relatedProduct.id} className="related-product-card">
                  <div className="related-product-image">
                    <img src={`/${relatedProduct.image}`} alt={relatedProduct.title} />
                  </div>
                  <div className="related-product-info">
                    <h4>{relatedProduct.title}</h4>
                    <p>{relatedProduct.description}</p>
                    <Link to={`/product/${relatedProduct.id}`} className="btn btn-secondary">
                      View Details
                    </Link>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
      {showEmailPopup && (
        <EmailPopup
          open={showEmailPopup}
          onClose={() => setShowEmailPopup(false)}
          onSubmit={handleEmailSubmit}
          product={product}
        />
      )}
      {emailConfirmed && (
        <div className="product-confirmation" style={{textAlign: 'center', margin: '2rem 0'}}>
          <h3>Thank you for your interest!</h3>
          <p>We have received your email. (Mock confirmation. Payment integration coming soon.)</p>
          <button className="btn btn-primary" onClick={() => setEmailConfirmed(false)}>Close</button>
        </div>
      )}
    </div>
  );
};

export default ProductDetails;  